import { FlowStorageHistoryType } from "./FlowStorageHistoryType";

export class FlowStorageHistory {
    historyDate: Date;
    historyType: FlowStorageHistoryType;
    userEmail: string;
    details: string;

    location: string = "";
    // can tag to a specific step
    currentStepId?: string;
    currentStepName?: string;
    currentStepType?: string;

    constructor(historyDate: Date, historyType: FlowStorageHistoryType, userEmail: string, details: string) {
        this.historyDate = historyDate;
        this.historyType = historyType;
        this.userEmail = userEmail;
        this.details = details;
    }
}
